export default {
  installment:          'Parcela',
  date:                 'Vencimento',
  original_debt:        'Valor em aberto da parcela',
  outstanding_amount:   'Valor da divida*',
  status:               'Status',
  paid_off:             'Pago',
  under_payment_plan:   'Em acordo',
  defaulted:            'Em atraso',
  pending:              'A vencer',
  next_payment_message: 'Seu pagamento leva até 3 dias úteis para processar',
  final_row_message:    'Seu empréstimo será pago',
};
